$(".announcement-close").click(function(){
  $("#shopify-section-announcement-bar").fadeOut();
});


// $('.slider-for').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   accessibility:false,
//   draggable:false,
//   swipe:false,
//   infinite: false,
//   touchMove:false,
//   asNavFor: '.slider-nav'
// });
// $('.slider-nav').slick({
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   infinite: false,
//   vertical:true,
//   asNavFor: '.slider-for',
//   dots: false,
//   focusOnSelect: true,
//   verticalSwiping:true,
//   responsive: [
//     {
//       breakpoint: 992,
//       settings: {
//         vertical: false,
//       }
//     },
//     {
//       breakpoint: 768,
//       settings: {
//         vertical: false,
//       }
//     },
//     {
//       breakpoint: 580,
//       settings: {
//         vertical: false,
//         slidesToShow: 4,
//       }
//     },
//     {
//       breakpoint: 380,
//       settings: {
//         vertical: false,
//         slidesToShow: 3,
//       }
//     }
//   ]
// });


$(window).on("load resize",function(e){
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    accessibility:false,
    draggable:false,
    swipe:false,
    infinite: false,
    touchMove:false,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          vertical: false,
        }
      },
      {
        breakpoint: 580,
        settings: {
          vertical: false,
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 380,
        settings: {
          vertical: false,
          slidesToShow: 3,
        }
      }
    ]
  });
  
  $('.icon.icon-caret').css('display','block');
});
